export const NODE_ENV = process.env.NODE_ENV;
export const isDevelopment = NODE_ENV === 'development';
export const isProduction = NODE_ENV === 'production';
export const isMockup = isDevelopment && window.location.host.includes('localhost');

export default {
    NODE_ENV,
    isDevelopment,
    isProduction,
    isMockup
};
